<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-form ref="classForm">
        <v-layout justify-center column class="pa-3">
          <v-flex xs12>
            <v-text-field label="类型名称" prepend-icon="$vuetify.icons.title" v-model="form.name" :disabled="disabledFlag">
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea label="类型描述" prepend-icon="$vuetify.icons.comment" v-model="form.description" rows="1" auto-grow  :disabled="disabledFlag">
            </v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
      <v-card-actions>
        <v-layout justify-center v-if="disabledFlag">
          <v-btn class="primary" @click="disabledFlag = !disabledFlag">修改</v-btn>
        </v-layout>
        <v-layout justify-center v-else>
          <v-btn class="primary" @click="submit" :loading="loading">提交</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </l-layout>
</template>

<script>
export default {
  name: 'classDetail',
  props: {
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      disabledFlag: true,
      form: {
        name: '',
        description: ''
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.form.name = this.formData.name
      this.form.description = this.formData.description
    },
    async submit () {
      let params = {
        id: this.formData.id,
        name: this.form.name,
        description: this.form.description,
        value: ''
      }
      let url = '/messageApi/admin/addMsgLabelType'
      this.loading = true
      try {
        let res = await this.$store.dispatch('message/addActions', {params: params, url: url})
        if (res.data.code + '' === '200') {
          this.$L.alert('success', {message: '更新成功'})
          this.disabledFlag = true
          this.$store.commit('message/setClassRefresh', true)
        }
        else {
          this.$L.alert('error', {message: '更新失败，原因：' + res.data.msg})
        }
      }
      catch (e) {
        console.log(e)
      }
      finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
